import { getUserData } from '@/auth/utils'

// id_manager_users backend'den array, JSON string, virgüllü string ya da tek değer olarak gelebilir.
// Hepsini number[]'a normalize eder.
const ADMIN_USER_TYPE = 1

export const parseManagerIds = raw => {
  if (raw === null || raw === undefined || raw === '') return []
  if (Array.isArray(raw)) return raw.map(Number).filter(n => !Number.isNaN(n))
  if (typeof raw === 'number') return [raw]
  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed)
        return Array.isArray(parsed) ? parsed.map(Number).filter(n => !Number.isNaN(n)) : []
      } catch (e) {
        return []
      }
    }
    return trimmed.split(',').map(s => Number(s.trim())).filter(n => !Number.isNaN(n))
  }
  return []
}

const currentUserId = () => {
  const user = getUserData()
  if (!user || user.id === undefined || user.id === null) return null
  const uid = Number(user.id)
  return Number.isNaN(uid) ? null : uid
}

// development.md:77-78 — yönetici (id_manager_users) ya da görevi oluşturan (id_users) silebilir/bitirebilir.
// Atananlar (watchers) bitiremez/silemez kuralı (line 78) bu whitelist ile dolaylı sağlanır:
// sadece watcher olan kullanıcı manager/owner değilse zaten false döner; aynı kişi hem manager
// hem watcher ise manager hakkı kazanır.
export const canManageTask = task => {
  if (!task) return false
  // Kapalı projenin yöneticisi iş akışının da yöneticisidir (BE TaskManagers::isManager).
  if (Number(task.is_project_manager)) return true
  const uid = currentUserId()
  if (uid === null) return false
  if (Number(task.id_users) === uid) return true
  return parseManagerIds(task.id_manager_users).includes(uid)
}

// Yalnız yönetici: oluşturan (id_users) yönetici değilse false döner. Alt görev silme kuralı.
// is_project_manager: kapalı projenin yöneticisi iş akışının da yöneticisidir (BE TaskManagers::isManager).
export const isTaskManager = task => {
  if (!task) return false
  if (Number(task.is_project_manager)) return true
  const uid = currentUserId()
  if (uid === null) return false
  return parseManagerIds(task.id_manager_users).includes(uid)
}

export const canDeleteTask = canManageTask
export const canCompleteTask = canManageTask

// Gözlemci yalnız görüntüler; düzenleme oluşturan ve yöneticinin hakkıdır.
export const canEditTask = canManageTask

const isProjectOwnerOrManager = project => {
  const uid = currentUserId()
  if (uid === null) return false
  return Number(project.id_users) === uid || parseManagerIds(project.id_manager_users).includes(uid)
}

// BE ProjectVisibility::canWrite: açık projede herkes, kapalıda oluşturan veya yönetici; admin kapalıda yalnız görür.
export const canWriteProject = project => {
  if (!project) return false
  return Number(project.is_public) === 1 || isProjectOwnerOrManager(project)
}

// BE ProjectVisibility::canChangeVisibility: açık projeyi yalnız oluşturan veya admin kapatır.
export const canChangeProjectVisibility = project => {
  if (!project) return false
  if (Number(project.is_public) !== 1) return isProjectOwnerOrManager(project)
  const uid = currentUserId()
  return Number(getUserData()?.id_user_types) === ADMIN_USER_TYPE || (uid !== null && Number(project.id_users) === uid)
}

// Alt görevin kronometresini oluşturan, yönetici ve o alt göreve atanan kullanır.
export const canUseSubtaskTimer = (task, subtask) => {
  if (canManageTask(task)) return true
  const uid = currentUserId()
  if (uid === null) return false
  return parseManagerIds(subtask?.assignees).includes(uid)
}
